/* eslint-disable react-hooks/exhaustive-deps */
import React, { useReducer, useEffect } from "react";

import AppContext from "./appContext";
import appReducer from "./appReducer";

import { useMsal } from "@azure/msal-react";
import { loginRequest, protectedRequest } from "../../authConfig";

import { CHANGE_STATE_MULTI } from "./types";
import { serverUrl } from "../../authConfig";
import axios from "axios";
import { trimJson } from "../../components/global/trimJson";

export const AppState = (props) => {
  const initialState = {
    msalUser: "",
    mode: "dev",
    authLevel: false,
    allStaff: [],
    approvalStreams: [],
    isApprover: false,
    medParms: [],
    eventCategories: [],
    categoryApprovers: [],
    categoryAdminSupport: [],
    travelAdmins: [],
    responseTypes: [],
    complianceOfficers: [],
  };

  const [state, dispatch] = useReducer(appReducer, initialState);
  const { instance, accounts } = useMsal();

  const requestAccessToken = async (resourceType) => {
    const requestType = () => {
      switch (resourceType) {
        case "graph":
          return loginRequest;

        case "protected":
          return protectedRequest;

        default:
          return loginRequest;
      }
    };

    // console.log("RequestAccessToken called");
    const request = {
      ...requestType(),
      account: accounts[0],
    };

    // Silently acquires an access token which is then attached to a request for Microsoft Graph data
    const userInfo = await instance
      .acquireTokenSilent(request)
      .then((response) => {
        return response;
      })

      .catch((e) => {
        console.log(e);
        // instance.acquireTokenRedirect(request).then((response) => {});
      });

    return userInfo;
  };

  const serverGet = async (endPoint, params) => {
    const tokenRes = await requestAccessToken("protected");
    const token = tokenRes.accessToken;

    try {
      const res = await axios.get(`${serverUrl}${endPoint}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { ...params, mode: initialState.mode },
      });
      return res.data;
    } catch (error) {
      console.log(error);
    }
  };

  const serverPost = async (endPoint, body, params) => {
    const tokenRes = await requestAccessToken("protected");
    const token = tokenRes.accessToken;

    try {
      const res = await axios.post(
        `${serverUrl}${endPoint}`,
        { ...body, mode: initialState.mode },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: { ...params, mode: initialState.mode },
        }
      );
      return res.data;
    } catch (error) {
      console.log(error);
    }
  };

  const serverPut = async (endPoint, body, params) => {
    const tokenRes = await requestAccessToken("protected");
    const token = tokenRes.accessToken;

    try {
      const res = await axios.put(`${serverUrl}${endPoint}`, body, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { ...params, mode: initialState.mode },
      });
      return res.data;
    } catch (error) {
      console.log(error);
    }
  };

  const serverDelete = async (endPoint, params) => {
    const tokenRes = await requestAccessToken("protected");
    const token = tokenRes.accessToken;

    try {
      const res = await axios.delete(`${serverUrl}${endPoint}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { ...params, mode: initialState.mode },
      });
      return res.data;
    } catch (error) {
      console.log(error);
    }
  };

  const authenticate = async () => {
    try {
      const res = await serverGet("/auth");

      dispatch({
        type: CHANGE_STATE_MULTI,
        payload: {
          ...res,
          msalUser: accounts[0],
          authLevel: res.authLevel,
          dbUser: res.dbUser,
          allStaff: trimJson(res.allStaff),
          approvalStreams: res.approvalStreams,
          isApprover: res.isApprover,
          medParms: trimJson(res.medParms),
          travelAdmins: res.travelAdmins,
          calendarCategories: res.calendarCategories,
          responseTypes: res.responseTypes,
          complianceOfficers: res.complianceOfficers.map((o) => o.email),
        },
      });
    } catch (error) {
      alert(error);
      instance.logoutRedirect({
        postLogoutRedirectUri: "/",
      });
    }
  };

  useEffect(() => {
    if (accounts[0]) {
      // console.log(accounts);
      authenticate();
    }
  }, [accounts]);

  useEffect(() => {
    if (state.authLevel) {
      setup();
    }
  }, [state.authLevel]);

  const setup = async () => {
    //get staff
  };

  const downloadBlob = async (containerName, blobName) => {
    const tokenRes = await requestAccessToken("protected");
    const token = tokenRes.accessToken;

    try {
      const res = await axios.get(
        `${serverUrl}/blob/download/${containerName}/${blobName}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: { mode: initialState.mode },
          responseType: "blob", // important to handle binary content
        }
      );

      const blob = new Blob([res.data]);
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = blobName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl); // clean up
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  return (
    <AppContext.Provider
      value={{
        msalUser: state.msalUser,
        authLevel: state.authLevel,
        allStaff: state.allStaff,
        dbUser: state.dbUser,
        mode: state.mode,
        approvalStreams: state.approvalStreams,
        isApprover: state.isApprover,
        medParms: state.medParms,
        eventCategories: state.eventCategories,
        categoryApprovers: state.categoryApprovers,
        categoryAdminSupport: state.categoryAdminSupport,
        travelAdmins: state.travelAdmins,
        calendarCategories: state.calendarCategories,
        responseTypes: state.responseTypes,
        complianceOfficers: state.complianceOfficers,
        requestAccessToken,
        serverGet,
        serverPost,
        serverDelete,
        serverPut,
        downloadBlob,
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
};
